import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PAY_URL } from "../../../BaseURL";
import toast from "react-hot-toast";

export const getUserShift = createAsyncThunk('/shift/getUserShift',
    async () => {
        try {
            const myurl = `${PAY_URL}/user/get-shift`;

            const response = await axios({
                method: 'get',
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const shiftDate = response.data;
            // console.log(shiftDate, "getUserShift response");

            if (shiftDate.success === true) {
                return shiftDate;
            } else {
                throw new Error(shiftDate.message);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error
        }
    })

const getUserShiftSlice = createSlice({
    name: "getUserShift",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserShift.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUserShift.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getUserShift.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getUserShiftSlice.reducer;